import { ReactNode } from 'react';

// Shared top bar so every in-game screen (lobby, question, solo, reveal) uses
// the same chrome — sticky, blurred, one background and border — instead of
// each rolling its own. Callers pass their own left/right content unchanged.
export function ScreenHeader({ left, right }: { left: ReactNode; right?: ReactNode }) {
  return (
    <header
      style={{
        padding: '0.85rem clamp(0.85rem, 3vw, 1.25rem)',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '0.5rem',
        borderBottom: '1px solid #2E2B45',
        background: 'rgba(15,13,31,0.9)',
        backdropFilter: 'blur(10px)',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      }}
    >
      {left}
      {right}
    </header>
  );
}
